import ApiService from '@/helpers/api.service'

// retrieve user email from the localstorage
let userData = JSON.parse(localStorage.getItem('userData'));
let userEmail = userData.email;


/*
*  Created by: 	Jero Paolo Balucas
*  Description:	getAccess - This function will fetch the access of role and then will return the finalized
                list of menus to be shown in the side menu
*  Params:		No params
*/
export function getAccess() {
    const API = new ApiService();
    return new Promise((resolve) => {
        // request to getUserAccess with email as param
        API.post(`/roles/getUserAccess`, { email: userEmail })
            .then(({ data }) => {
                localStorage.setItem('userAccess', JSON.stringify(data.message.row))

                let user = data.message.row
                // let modules = user[0].access == null || user[0].access == "" ? null : JSON.parse(user[0].access);
                let modules = [];
                let access = user[0].access == null || user == "" ? null : JSON.parse(user[0].access);
                // let category = access == null ? null : access.find(({ title }) => title == categoryName);

                if (access != null) {
                    for (let category of access) {
                        for (let module of category.modules) {
                            modules.push(module);
                        }
                    }
                }

                // set the object per module and submodules based on module/submodule name
                let KankolekDashboard = modules == null ? {} : handleUndefinedModule(modules.find(({ name }) => name == 'Kankolek')),
                    EloadProvider = modules == null ? {} : handleUndefinedModule(modules.find(({ name }) => name == 'Eload Proviver')),
                    BusinessInfo = modules == null ? {} : handleUndefinedModule(modules.find(({ name }) => name == 'Business Info')),
                    Merchant = modules == null ? {} : handleUndefinedModule(modules.find(({ name }) => name == 'Merchant')),
                    CustomerLoyalty = modules == null ? {} : handleUndefinedModule(modules.find(({ name }) => name == 'Customer Loyalty')),
                    BLVCKCoins = modules == null ? {} : handleUndefinedModule(modules.find(({ name }) => name == 'BLVCK Coins')),
                    //BLVCKCoinsRewards = modules == null ? {} : modules.find(({ name }) => name == 'Blvck Coins Rewards'),
                    eLoad = modules == null ? {} : handleUndefinedModule(modules.find(({ name }) => name == 'eLoad')),
                    eLoadPromo = modules == null ? {} : handleUndefinedModule(eLoad.submodules.find(({ name }) => name == 'eLoad Promo')),
                    eLoadCategory = modules == null ? {} : handleUndefinedModule(eLoad.submodules.find(({ name }) => name == 'eLoad Category')),
                    eLoadTopups = modules == null ? {} : handleUndefinedModule(eLoad.submodules.find(({ name }) => name == 'eLoad Topups')),
                    // eLoadNetworks = modules == null ? {} : handleUndefinedModule(eLoad.submodules.find(({ name }) => name == 'eLoad Networks')),
                    eLoadNetworkGroup = modules == null ? {} : handleUndefinedModule(eLoad.submodules.find(({ name }) => name == 'eLoad Network Group')),
                    eLoadBanner = modules == null ? {} : handleUndefinedModule(eLoad.submodules.find(({ name }) => name == 'eLoad Banner')),
                    eLoadProvider = modules == null ? {} : handleUndefinedModule(eLoad.submodules.find(({ name }) => name == 'eLoad Provider')),
                    BillsPayment = modules == null ? {} : handleUndefinedModule(modules.find(({ name }) => name == 'Bills Payment')),
                    BillsPaymentList = modules == null ? {} : handleUndefinedModule(BillsPayment.submodules.find(({ name }) => name == 'Bills Payment')),
                    BillsPaymentProvider = modules == null ? {} : handleUndefinedModule(BillsPayment.submodules.find(({ name }) => name == 'Bills Payment Provider')),
                    BillsPaymentCategory = modules == null ? {} : handleUndefinedModule(BillsPayment.submodules.find(({ name }) => name == 'Bills Payment Category')),
                    MobileLegendDiamond = modules == null ? {} : handleUndefinedModule(modules.find(({ name }) => name == 'Mobile Legend Diamond')),
                    eSupplies = modules == null ? {} : handleUndefinedModule(modules.find(({ name }) => name == 'eSupplies')),
                    Sellers = modules == null ? {} : handleUndefinedModule(eSupplies.submodules.find(({ name }) => name == 'Sellers')),
                    Categories = modules == null ? {} : handleUndefinedModule(eSupplies.submodules.find(({ name }) => name == 'Categories')),
                    Products = modules == null ? {} : handleUndefinedModule(eSupplies.submodules.find(({ name }) => name == 'Products')),
                    Banners = modules == null ? {} : handleUndefinedModule(eSupplies.submodules.find(({ name }) => name == 'Banners')),
                    Orders = modules == null ? {} : handleUndefinedModule(eSupplies.submodules.find(({ name }) => name == 'Orders')),
                    PRP = modules == null ? {} : handleUndefinedModule(modules.find(({ name }) => name == 'PRP')),
                    PRPRewards = modules == null ? {} : handleUndefinedModule(PRP.submodules.find(({ name }) => name == 'PRP Rewards')),
                    PRPCategory = modules == null ? {} : handleUndefinedModule(PRP.submodules.find(({ name }) => name == 'PRP Category')),
                    PRPItems = modules == null ? {} : handleUndefinedModule(PRP.submodules.find(({ name }) => name == 'PRP Items')),
                    ProductTemplate = modules == null ? {} : handleUndefinedModule(modules.find(({ name }) => name == 'Product Template')),
                    ProductSuggestion = modules == null ? {} : handleUndefinedModule(ProductTemplate.submodules.find(({ name }) => name == 'Product Suggestion')),
                    ProductBrand = modules == null ? {} : handleUndefinedModule(ProductTemplate.submodules.find(({ name }) => name == 'Product Brand')),
                    ProductCategory = modules == null ? {} : handleUndefinedModule(ProductTemplate.submodules.find(({ name }) => name == 'Product Category')),
                    Roulette = modules == null ? {} : handleUndefinedModule(modules.find(({ name }) => name == 'Roulette')),
                    RouletteMain = modules == null ? {} : handleUndefinedModule(Roulette.submodules.find(({ name }) => name == 'Roulette Main')),
                    RouletteItem = modules == null ? {} : handleUndefinedModule(Roulette.submodules.find(({ name }) => name == 'Roulette Item')),
                    RouletteReward = modules == null ? {} : handleUndefinedModule(Roulette.submodules.find(({ name }) => name == 'Roulette Reward')),
                    BusinessCategory = modules == null ? {} : handleUndefinedModule(modules.find(({ name }) => name == 'Business Category')),
                    Events = modules == null ? {} : handleUndefinedModule(modules.find(({ name }) => name == 'Events')),
                    Careers = modules == null ? {} : handleUndefinedModule(modules.find(({ name }) => name == 'Careers')),
                    DepartmentTeam = modules == null ? {} : handleUndefinedModule(Careers.submodules.find(({ name }) => name == 'Department Teams')),
                    JobOpening = modules == null ? {} : handleUndefinedModule(Careers.submodules.find(({ name }) => name == 'Job Opening')),
                    ELoadTransactionLogs = modules == null ? {} : handleUndefinedModule(modules.find(({ name }) => name == 'ELoad Transaction Logs')),
                    EloadLogsTopups = modules == null ? {} : handleUndefinedModule(ELoadTransactionLogs.submodules.find(({ name }) => name == 'Top-ups')),
                    EloadLogsRewards = modules == null ? {} : handleUndefinedModule(ELoadTransactionLogs.submodules.find(({ name }) => name == 'Rewards')),
                    EloadLogsSellEload = modules == null ? {} : handleUndefinedModule(ELoadTransactionLogs.submodules.find(({ name }) => name == 'Sell-eload')),
                    BLVCKTransactionLogs = modules == null ? {} : handleUndefinedModule(modules.find(({ name }) => name == 'BLVCK Transaction Logs')),
                    BLVCKLogTopups = modules == null ? {} : handleUndefinedModule(BLVCKTransactionLogs.submodules.find(({ name }) => name == 'Top-ups')),
                    BLVCKLogRewards = modules == null ? {} : handleUndefinedModule(BLVCKTransactionLogs.submodules.find(({ name }) => name == 'Rewards')),
                    BillsPaymentTransactionLogs = modules == null ? {} : handleNoPropertyExist(modules,null,'Bills Payment Transaction Logs'),
                    BillsPaymentTopupLogs = modules == null ? {} : handleNoPropertyExist(BillsPaymentTransactionLogs,"submodules",'Top-ups'),
                    BillsPaymentSellLogs = modules == null ? {} : handleNoPropertyExist(BillsPaymentTransactionLogs,"submodules",'Sell Bills payment'),
                    AgentTransactionLogs = modules == null ? {} : handleUndefinedModule(modules.find(({ name }) => name == 'Agent Transaction Logs')),
                    UserManagement = modules == null ? {} : handleUndefinedModule(modules.find(({ name }) => name == 'User Management')),
                    Roles = modules == null ? {} : handleUndefinedModule(UserManagement.submodules.find(({ name }) => name == 'Roles')),
                    Users = modules == null ? {} : handleUndefinedModule(UserManagement.submodules.find(({ name }) => name == 'Users')),
                    ProfitSharing = modules == null ? {} : handleUndefinedModule(modules.find(({ name }) => name == 'Profit Sharing')),
                    ModesOfPayment = modules == null ? {} : handleUndefinedModule(modules.find(({ name }) => name == 'Modes of Payment')),
                    KantoAds = modules == null ? {} : handleNoPropertyExist(modules,null,'Kanto Ads'),
                    KantoAdsTopup = modules == null ? {} : handleNoPropertyExist(KantoAds,"submodules",'Top-up Bank Transfer'),
                    KantoAdsAudit = modules == null ? {} : handleNoPropertyExist(KantoAds,"submodules",'Audit'),
                    KantoAdsCashout = modules == null ? {} : handleNoPropertyExist(KantoAds,"submodules",'Wallet Cashout'),
                    MaintenanceMode = modules == null ? {} : handleUndefinedModule(modules.find(({ name }) => name == 'Maintenance Mode')),
                    CIFMobileNumber = modules == null ? {} : handleUndefinedModule(modules.find(({ name }) => name == 'CIF Mobile Number')),
                    eloadB2b = modules == null ? {} : handleUndefinedModule(modules.find(({ name }) => name == 'eLoad B2B')),
                    eloadB2bRequest = modules == null ? {} : handleUndefinedModule(eloadB2b.submodules.find(({ name }) => name == 'Request')),
                    eloadB2bTransaction = modules == null ? {} : handleUndefinedModule(eloadB2b.submodules.find(({ name }) => name == 'Transaction'));
                    
                // console.log('KantoAds: ', KantoAds)
                // console.log(":::: eloadB2b ::::",eloadB2b,setShowMenuValue(eloadB2bRequest),setShowMenuValue(eloadB2bTransaction))
                // console.log(":::: eloadB2bRequest ::::",eloadB2bRequest)
                // console.log(":::: eloadB2bTransaction ::::",eloadB2bTransaction)
                // console.log(":::: EloadProvider ::::",EloadProvider)
                // console.log(":: BusinessCategory :: " , BusinessCategory);
                let modulesUnderDashboard = [KankolekDashboard];

                let modulesUnderMerchantMngt = [BusinessInfo, Merchant, CustomerLoyalty];

                let modulesUnderProducts = [BLVCKCoins, eLoadPromo, eLoadCategory, eLoadTopups/*, eLoadNetworks*/, eLoadNetworkGroup, 
                                            eLoadBanner, eLoadProvider, BillsPaymentList, BillsPaymentProvider, BillsPaymentCategory, MobileLegendDiamond, Sellers, Categories, 
                                            Products, Banners, Orders, KantoAdsTopup, KantoAdsAudit, KantoAdsCashout, eloadB2b, eloadB2bRequest, eloadB2bTransaction];

                let modulesUnderUtilities = [PRPRewards, PRPCategory, PRPItems, ProductSuggestion, ProductBrand, ProductCategory, 
                                            RouletteMain, RouletteItem, RouletteReward, BusinessCategory,
                                            Events, DepartmentTeam, JobOpening];
                
                let modulesUnderReports = [EloadLogsTopups, EloadLogsRewards, EloadLogsSellEload, BLVCKLogTopups,
                                            BLVCKLogRewards, BLVCKLogRewards, AgentTransactionLogs,
                                            BillsPaymentTopupLogs, BillsPaymentSellLogs];

                let modulesUnderSettings = [Roles, Users, ProfitSharing, ModesOfPayment, MaintenanceMode];     

                let modulesUnderEloadProvider = [EloadProvider];
                
                // let modulesUnderMaintenanceMode = [MaintenanceMode];
                
                // these variables are being used to check if the Title of menu section will be shown
                /* eslint-disable-next-line no-unused-vars */
                let showMerchantMngtTitle = false;
                /* eslint-disable-next-line no-unused-vars */
                let showProductsTitle = false;
                /* eslint-disable-next-line no-unused-vars */
                let showUtilitiesTitle = false;
                let showReportsTitle = false;
                let showSettingsTitle = false;
                let showDashboardTitle = false;
                /* eslint-disable-next-line no-unused-vars */
                let showEloadProvider = false;
                // let showMaintenanceTitle = false;

                for (let item of modulesUnderDashboard) {
                    if (setShowMenuValue(item)) {
                        showDashboardTitle = true;
                        break;
                    }
                }

                for (let item of modulesUnderMerchantMngt) {
                    if (setShowMenuValue(item)) {
                        showMerchantMngtTitle = true;
                        break;
                    }
                }

                for (let item of modulesUnderProducts) {
                    if (setShowMenuValue(item)) {
                        showProductsTitle = true;
                        break;
                    }
                }
                // console.log('showProductsTitle: ', showProductsTitle);
                // console.log('showMerchantMngtTitle: ', showMerchantMngtTitle);
                // console.log('showDashboardTitle: ', showDashboardTitle);
                // console.log('showUtilitiesTitle: ', showUtilitiesTitle);

                for (let item of modulesUnderUtilities) {
                    if (setShowMenuValue(item)) {
                        showUtilitiesTitle = true;
                        break;
                    }
                }

                for (let item of modulesUnderReports) {
                    if (setShowMenuValue(item)) {
                        showReportsTitle = true;
                        break;
                    }
                }

                for (let item of modulesUnderSettings) {
                    if (setShowMenuValue(item)) {
                        showSettingsTitle = true;
                        break;
                    }
                }

                for (let item of modulesUnderEloadProvider) {
                    if (setShowMenuValue(item)) {
                        showEloadProvider = true;
                        break;
                    }
                }

                // for (let item of modulesUnderMaintenanceMode) {
                //     if (setShowMenuValue(item)) {
                //         showMaintenanceTitle = true;
                //         break;
                //     }
                // }
                console.log('showDashboardTitle: ', showDashboardTitle);

                // array of menus, the enabled prop is being used to check if a menu will be shown
                console.log('about to retrieve menu items')
                let menuItems = [
                    /* Overview */
                    {
                        label: 'menuitems.overview.text',
                        icon: 'tachometer',
                        enabled: modules == null ? false : setShowMenuValue(KankolekDashboard),
                        hasSeparator: true,
                        subItems: [
                        {
                            label: 'menuitems.overview.dashboard',
                            link: { name: 'Dashboard' },
                            enabled: true
                        },
                        {
                            label: 'menuitems.overview.eload-dashboard',
                            link: { name: 'E-Load Dashboard' },
                            enabled: true
                        },
                        {
                            label: 'menuitems.overview.kankolek',
                            link: { name: 'KanKolek Dashboard' },
                            enabled: modules == null ? false : setShowMenuValue(KankolekDashboard)
                        },
                        {
                            label: 'menuitems.overview.eload-provider',
                            link: { name: 'Eload Provider' },
                            enabled: modules == null ? false : setShowMenuValue(KankolekDashboard)
                        }
                        ]
                    },

                    /* POS Tools - New menu structure from Figma design */
                    {
                        label: 'menuitems.pos-tools.text',
                        icon: 'store-alt',
                        enabled: true,
                        hasSeparator: true,
                        subItems: [
                        {
                            label: 'menuitems.pos-tools.product-directory',
                            enabled: 
                            (modules == null ? false : setShowMenuValue(ProductSuggestion)) ||
                            (modules == null ? false : setShowMenuValue(ProductBrand)) ||
                            (modules == null ? false : setShowMenuValue(ProductCategory)),
                            subItems: [
                            {
                                label: 'menuitems.pos-tools.business-category',
                                link: { name: 'Business Category' },
                                enabled: modules == null ? false : setShowMenuValue(BusinessCategory)
                            },
                            {
                                label: 'menuitems.pos-tools.product-category',
                                link: { name: 'Product Group' },
                                enabled: modules == null ? false : setShowMenuValue(ProductCategory)
                            },
                            {
                                label: 'menuitems.pos-tools.product-brand',
                                link: { name: 'Product Brand' },
                                enabled: modules == null ? false : setShowMenuValue(ProductBrand)
                            },
                            {
                                label: 'menuitems.pos-tools.product-suggestions',
                                link: { name: 'Product Template' },
                                enabled: modules == null ? false : setShowMenuValue(ProductSuggestion)
                            }
                            ]
                        },
                        {
                            label: 'menuitems.pos-tools.roulette',
                            enabled:
                            (modules == null ? false : setShowMenuValue(RouletteMain)) ||
                            (modules == null ? false : setShowMenuValue(RouletteItem)) ||
                            (modules == null ? false : setShowMenuValue(RouletteReward)),
                            subItems: [
                            {
                                label: 'menuitems.roulette.list.roulette-main',
                                link: { name: 'Roulette Main' },
                                enabled: modules == null ? false : setShowMenuValue(RouletteMain)
                            },
                            {
                                label: 'menuitems.roulette.list.roulette-item',
                                link: { name: 'Roulette Item' },
                                enabled: modules == null ? false : setShowMenuValue(RouletteItem)
                            },
                            {
                                label: 'menuitems.roulette.list.roulette-reward',
                                link: { name: 'Roulette Reward' },
                                enabled: modules == null ? false : setShowMenuValue(RouletteReward)
                            },
                            {
                                label: 'menuitems.raffle-promo.text',
                                link: { name: 'Raffle Promo' },
                                enabled: true
                            }
                            ]
                        }
                        ]
                    },

                    /* PEDDLR-7104: Merchant List is a top-level menu immediately after POS Tools, per Figma. */
                    {
                        label: 'menuitems.pos-tools.merchant-list',
                        icon: 'user-circle',
                        enabled: modules == null ? false : setShowMenuValue(Merchant),
                        hasSeparator: true,
                        subItems: [
                        {
                            label: 'menuitems.pos-tools.merchant-lite',
                            link: { name: 'Merchant Lite' },
                            enabled: modules == null ? false : setShowMenuValue(Merchant)
                        },
                        {
                            label: 'menuitems.pos-tools.merchant-app',
                            link: { name: 'Subscriber' },
                            enabled: modules == null ? false : setShowMenuValue(Merchant)
                        }
                        ]
                    },

                    /* E-Load Core Section */
                    {
                        label: 'E-LOAD CORE',
                        isTitle: true,
                        enabled: true
                    },

                    /* E-Load Core Manager - New menu structure from Figma design */
                    {
                        label: 'menuitems.eload-core.text',
                        icon: `extension`,
                        // customIcon: {
                        //     icon: `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        //         <g clip-path="url(#clip0_16668_7277)">
                        //         <path d="M16.5 8.25V5.25C16.5 4.147 15.603 3.25 14.5 3.25H11.5C11.5 1.596 10.154 0.25 8.49997 0.25C6.84597 0.25 5.49997 1.596 5.49997 3.25H2.49997C1.39697 3.25 0.499969 4.147 0.499969 5.25V9.131L1.15897 9.37C1.96097 9.66 2.49997 10.416 2.49997 11.25C2.49997 12.084 1.96097 12.84 1.15897 13.13L0.499969 13.369V17.25C0.499969 18.353 1.39697 19.25 2.49997 19.25H6.38097L6.61997 18.591C6.90997 17.789 7.66597 17.25 8.49997 17.25C9.33397 17.25 10.09 17.789 10.38 18.591L10.619 19.25H14.5C15.603 19.25 16.5 18.353 16.5 17.25V14.25C18.154 14.25 19.5 12.904 19.5 11.25C19.5 9.596 18.154 8.25 16.5 8.25ZM16.5 12.25H14.5L14.497 17.25H11.952C11.241 16.03 9.92997 15.25 8.49997 15.25C7.06997 15.25 5.75897 16.03 5.04797 17.25H2.49997V14.702C3.71997 13.991 4.49997 12.68 4.49997 11.25C4.49997 9.82 3.71997 8.509 2.49997 7.798V5.25H7.49997V3.25C7.49997 2.98478 7.60533 2.73043 7.79286 2.54289C7.9804 2.35536 8.23475 2.25 8.49997 2.25C8.76519 2.25 9.01954 2.35536 9.20708 2.54289C9.39461 2.73043 9.49997 2.98478 9.49997 3.25V5.25H14.5V10.25H16.5C16.7652 10.25 17.0195 10.3554 17.2071 10.5429C17.3946 10.7304 17.5 10.9848 17.5 11.25C17.5 11.5152 17.3946 11.7696 17.2071 11.9571C17.0195 12.1446 16.7652 12.25 16.5 12.25Z" fill="black"/>
                        //         </g>
                        //         <defs>
                        //         <clipPath id="clip0_16668_7277">
                        //         <rect width="20" height="20" fill="white"/>
                        //         </clipPath>
                        //         </defs>
                        //         </svg>

                        //         `,
                        //     css_properties: 'width: 12px !important; height: 12px !important; margin-bottom: 15px; margin-right: 8px; vertical-align: middle;'
                        // },
                        enabled: true,
                        subItems: [
                        {
                            label: 'menuitems.eload-core.sku-master',
                            link: { name: 'E-Load Core SKU Master' }, 
                            enabled: true
                        },
                        {
                            label: 'menuitems.eload-core.sku',
                            link: { name: 'E-Load Core SKU' }, 
                            enabled: true
                        },
                        {
                            label: 'menuitems.eload-core.provider',
                            link: { name: 'E-Load Core Provider' },
                            enabled: modules == null ? false : setShowMenuValue(eLoadProvider)
                        },
                        {
                            label: 'menuitems.eload-core.networks',
                            link: { name: 'E-Load Core Network' },
                            enabled: modules == null ? false : setShowMenuValue(eLoadNetworkGroup)
                        },
                        /*{
                            label: 'menuitems.eload-core.category',
                            link: { name: 'Category Promo' },
                            enabled: modules == null ? false : setShowMenuValue(eLoadCategory)
                        },
                        {
                            label: 'menuitems.eload-core.special-category',
                            link: { name: 'E-Load Special Category' },
                            enabled: true
                        },
                        {
                            label: 'menuitems.eload-core.topups',
                            link: { name: 'E-Load Topups' },
                            enabled: modules == null ? false : setShowMenuValue(eLoadTopups)
                        },
                        {
                            label: 'menuitems.eload-core.topup-mop',
                            link: { name: 'ModeOfPayment' },
                            enabled: modules == null ? false : setShowMenuValue(ModesOfPayment)
                        }, */
                        {
                            label: 'menuitems.eload-core.maintenance',
                            link: { name: 'E-Load Core Maintenance' },
                            enabled: true
                        },
                        {
                            label: 'menuitems.eload-core.scheduler',
                            link: { name: 'E-Load Core SKU Schedule' },
                            enabled: true
                        },
                        {
                            label: 'menuitems.eload-core.sku-test',
                            link: { name: 'E-Load SKU Test' }, // TODO: Verify if this page exists in current structure
                            enabled: true
                        },
                        ]
                    },

                    /* E-Load Retail (Peddlr Lite) Section */
                    {
                        label: 'E-LOAD RETAIL (PEDDLR LITE)',
                        isTitle: true,
                        enabled: true
                    },

                    /* Peddlr Lite Manager - New menu structure from Figma design */
                    {
                        label: 'menuitems.peddlr-lite.text',
                        icon: `mobile-alt`,
                        // customIcon: {
                        //     icon: `<svg width="12" height="17" viewBox="0 0 12 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                        //         <path d="M10 0H1.66667C0.7475 0 0 0.7475 0 1.66667V15C0 15.9192 0.7475 16.6667 1.66667 16.6667H10C10.9192 16.6667 11.6667 15.9192 11.6667 15V1.66667C11.6667 0.7475 10.9192 0 10 0ZM1.66667 15V1.66667H10L10.0017 15H1.66667Z" fill="black"/>
                        //         <path d="M5.83333 14.1667C6.29357 14.1667 6.66667 13.7936 6.66667 13.3333C6.66667 12.8731 6.29357 12.5 5.83333 12.5C5.3731 12.5 5 12.8731 5 13.3333C5 13.7936 5.3731 14.1667 5.83333 14.1667Z" fill="black"/>
                        //         </svg>
                        //         `,
                        //     css_properties: 'width: 18px; height: 18px; margin-bottom: 8px; margin-right: 8px; vertical-align: middle;'
                        // },
                        enabled: true,
                        subItems: [
                        {
                            label: 'menuitems.peddlr-lite.sku',
                            link: { name: 'E-Load Lite SKU Manager' },
                            enabled: modules == null ? false : setShowMenuValue(eLoadPromo)
                        },
                        {
                            label: 'menuitems.eload-core.networks',
                            link: { name: 'E-Load Network Group' },
                            enabled: modules == null ? false : setShowMenuValue(eLoadNetworkGroup)
                        },
                        {
                            label: 'menuitems.peddlr-lite.category',
                            link: { name: 'E-Load Lite Category Promo' },
                            enabled: modules == null ? false : setShowMenuValue(eLoadCategory)
                        },
                        {
                            label: 'menuitems.peddlr-lite.special-category',
                            link: { name: 'E-Load Special Category' },
                            enabled: true
                        },
                        {
                            label: 'menuitems.peddlr-lite.topups',
                            link: { name: 'E-Load Topups' },
                            enabled: modules == null ? false : setShowMenuValue(eLoadTopups)
                        },
                        {
                            label: 'menuitems.peddlr-lite.topup-mop',
                            link: { name: 'ModeOfPayment' },
                            enabled: modules == null ? false : setShowMenuValue(ModesOfPayment)
                        },
                        {
                            label: 'menuitems.peddlr-lite.maintenance',
                            link: { name: 'Eload Maintenance' },
                            enabled: true
                        }
                        ]
                    },

                    /* GBITS E-Load B2B Section */
                    {
                        label: 'GBITS E-LOAD B2B',
                        isTitle: true,
                        enabled: true
                    },

                    /* GBITS Manager - New menu structure from Figma design */
                    {
                        label: 'menuitems.gbits.text',
                        customIcon: {
                            icon: `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M5.6057 4.69092C6.80785 4.69092 7.87703 5.14089 8.59026 5.92934V5.91053C8.59026 5.2161 9.24708 4.72718 10.0355 4.72718C10.8804 4.72718 11.5748 5.40281 11.5748 6.22887V13.9065C11.5748 17.0791 9.45393 18.75 6.374 18.75C5.15439 18.75 2.05566 18.4304 2.05566 16.6856C2.05566 15.9723 2.58085 15.4283 3.29408 15.4283C3.67017 15.4283 4.02612 15.5788 4.42101 15.748C5.02142 16.0489 5.69704 16.1604 6.42907 16.1604C7.55601 16.1604 8.49355 15.5412 8.49355 13.9831V13.3451C7.76151 14.0959 6.76621 14.5284 5.60301 14.5284C3.07111 14.5284 1.26855 12.519 1.26855 9.68488C1.26855 6.68152 3.14633 4.69092 5.6057 4.69092ZM6.43176 7.39475C5.17454 7.39475 4.27326 8.35244 4.27326 9.72249C4.27326 11.0925 5.17454 12.0126 6.43176 12.0126C7.68898 12.0126 8.55265 11.0737 8.55265 9.72249C8.55265 8.37125 7.67018 7.39475 6.43176 7.39475Z" fill="#191919"/>
                                <path d="M8.44397 2.27049C8.44397 1.42562 9.11959 0.75 9.98326 0.75C10.8469 0.75 11.5037 1.42562 11.5037 2.27049V5.40548C12.217 4.80508 13.1371 4.4666 14.2076 4.4666C16.855 4.4666 18.7314 6.54988 18.7314 9.47937C18.7314 12.4089 16.5917 14.5297 13.5682 14.5297C10.5447 14.5297 8.44263 12.4465 8.44263 9.47937V2.27049H8.44397ZM15.7281 9.47937C15.7281 8.12812 14.8456 7.17043 13.5696 7.17043C12.2935 7.17043 11.4487 8.12812 11.4487 9.47937C11.4487 10.8306 12.3311 11.8259 13.5696 11.8259C14.808 11.8259 15.7281 10.8682 15.7281 9.47937Z" fill="black"/>
                                </svg>
                                `,
                            css_properties: 'width: 18px; height: 18px; margin-bottom: 8px; margin-right: 8px; vertical-align: middle;'
                        },
                        hasSeparator: true,
                        enabled: true,
                        subItems: [
                        {
                            label: 'menuitems.gbits.sku',
                            link: { name: 'Eload B2B Requests' },
                            enabled: modules == null ? false : setShowMenuValue(eloadB2bRequest)
                        },
                        {
                            label: 'menuitems.gbits.client-list',
                            link: { name: 'Subscriber' },
                            enabled: modules == null ? false : setShowMenuValue(Merchant)
                        },
                        {
                            label: 'menuitems.gbits.maintenance',
                            link: { name: 'Eload Maintenance' },
                            enabled: true
                        },
                        {
                            label: 'menuitems.gbits.gbits-account-creation',
                            link: { name: 'GBITS Account Creation' },
                            enabled: true
                        },
                        {
                            label: 'menuitems.gbits.topup-request-approval',
                            link: { name: 'GBITS Topup Request Approval' },
                            enabled: true
                        }
                        ]
                    },

                    /* Bills Pay Manager */
                    {
                        label: 'menuitems.bills-payment.text',
                        icon: 'receipt',
                        hasSeparator: true,
                        enabled:
                        (modules == null ? false : setShowMenuValue(BillsPaymentList)) ||
                        (modules == null ? false : setShowMenuValue(BillsPaymentCategory)) ||
                        (modules == null ? false : setShowMenuValue(BillsPaymentProvider)),
                        subItems: [
                        {
                            label: 'menuitems.bills-payment.sku',
                            link: { name: 'Bills Payment' },
                            enabled: modules == null ? false : setShowMenuValue(BillsPaymentList)
                        },
                        {
                            label: 'menuitems.bills-payment.provider',
                            link: { name: 'Bills Payment Provider' },
                            enabled: modules == null ? false : setShowMenuValue(BillsPaymentProvider)
                        },
                        {
                            label: 'menuitems.bills-payment.category',
                            link: { name: 'Bills Payment Category' },
                            enabled: modules == null ? false : setShowMenuValue(BillsPaymentCategory)
                        }
                        ]
                    },

                    /* Kankolek Manager */
                    {
                        label: 'menuitems.kankolek.text',
                        // TODO: Create Kankolek page - currently not implemented
                        customIcon: {
                            icon: `<svg width="20" height="20" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                    <rect width="16" height="13.5" fill="url(#pattern0_16695_7177)"/>
                                    <defs>
                                    <pattern id="pattern0_16695_7177" patternContentUnits="objectBoundingBox" width="1" height="1">
                                    <use xlink:href="#image0_16695_7177" transform="scale(0.03125 0.037037)"/>
                                    </pattern>
                                    <image id="image0_16695_7177" width="32" height="27" preserveAspectRatio="none" xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAbCAYAAAAdx42aAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAF0SURBVHgBvZbBUcMwEEW/kgtHpwN1gDvAdMCVE+kgoYLAjWOoAHzjCBVEVJDQgakgLoFdvIo9GmEcJ9o3s5Gytkff31pJQAdr7ZZiTzGHEpPgfybhoEQowFLsKgJKHASQ7bl0P6FI14FC2gqKdAUspK2hyK8AmfVWcjkU8Q6sOrlLKGLo7QtqN0F+RoWg8inYgZtIfgklWEDM8gU5k0EBFhCbdDz4CgpMZLAYS5kfyQX08ZL6U7CAque6pdikFMECvv65JxcRFokEuAH3eRFznBkj9u6PeKai+KBYn2PbNvxDItZoN6Nj2KHZvh1GniO8AHZhi3ZDGkstorj9ltZHDGd8Tw4kvCeorIBCdVgHyD1Wfg3d80BpwoyUGzthkZZHeumHaZitG56zLGNxBdJwT4M/cWf61x0kwpGIkrozNG5c4HR40bulwd98wgx5SqqEzw13GOeKoyhp4NfwwiABETG5CLlCUzUWbfX4svNrxHvf+vADWhdmHeFOGoUAAAAASUVORK5CYII="/>
                                    </defs>
                                    </svg>
                            `,
                            css_properties: 'margin-left: 3px; margin-bottom: 11px; margin-right: 6px; vertical-align: middle;'
                        },
                        // icon: 'food-menu',
                        enabled: true,
                        hasSeparator: true,
                        subItems: [
                        {
                            label: 'menuitems.kankolek.cif-setup',
                            link: { name: 'CIF Mobile Number' },
                            enabled: modules == null ? false : setShowMenuValue(CIFMobileNumber)
                        },
                        {
                            label: 'menuitems.kankolek.deposit',
                            link: { name: 'Kankolek Deposit' },
                            enabled: true
                        },
                        {
                            label: 'menuitems.kankolek.maintenance',
                            link: { name: 'Maintenance Mode' },
                            enabled: true
                        },
                        {
                            label: 'menuitems.kankolek.standalone-account-creation',
                            link: { name: 'KK Web Account Invitation' },
                            enabled: true
                        },
                        {
                            label: 'menuitems.kankolek.wallet-freezing',
                            link: { name: 'Wallet Freezing' },
                            enabled: true
                        },
                        {
                            label: 'menuitems.kankolek.transaction-monitoring',
                            link: { name: 'Transaction Monitoring' },
                            enabled: true
                        }
                        ]
                    },

                    /* Reports & Logs (Collapsible) */
                    {
                        label: 'REPORTS & LOGS',
                        isTitle: true,
                        isCollapsible: true,
                        enabled: showReportsTitle,
                        subItems: [
                        {
                            label: 'Peddlr Puhunan (GoTyme)',
                            customIcon: {
                                icon:
                                 `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M11.6667 1.66675H5.00001C4.55798 1.66675 4.13406 1.84234 3.8215 2.1549C3.50894 2.46746 3.33334 2.89139 3.33334 3.33341V16.6667C3.33334 17.1088 3.50894 17.5327 3.8215 17.8453C4.13406 18.1578 4.55798 18.3334 5.00001 18.3334H15C15.442 18.3334 15.866 18.1578 16.1785 17.8453C16.4911 17.5327 16.6667 17.1088 16.6667 16.6667V6.66675L11.6667 1.66675Z" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M11.6667 1.66675V6.66675H16.6667" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M13.3333 10.8333H6.66666" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M13.3333 14.1667H6.66666" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M8.33332 7.5H7.49999H6.66666" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                `,
                                css_properties: 'margin-right: 8px; margin-bottom: 7px; vertical-align: middle;'
                            },
                            enabled: true,
                            subItems: [
                            {
                                label: 'Puhunan Analytics CTR',
                                link: { name: 'Peddlr Puhunan CTR' },
                                enabled: true,
                            },
                            {
                                label: 'Puhunan Offers',
                                link: { name: 'Puhunan Offers' },
                                enabled: true,
                            },
                            {
                                label: 'Puhunan Disbursed',
                                link: { name: 'Puhunan Disbursed' },
                                enabled: true,
                            }
                            ]
                        },
                        {
                            label: 'menuitems.eload-transaction-logs.text',
                            customIcon: {
                                icon:
                                 `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M11.6667 1.66675H5.00001C4.55798 1.66675 4.13406 1.84234 3.8215 2.1549C3.50894 2.46746 3.33334 2.89139 3.33334 3.33341V16.6667C3.33334 17.1088 3.50894 17.5327 3.8215 17.8453C4.13406 18.1578 4.55798 18.3334 5.00001 18.3334H15C15.442 18.3334 15.866 18.1578 16.1785 17.8453C16.4911 17.5327 16.6667 17.1088 16.6667 16.6667V6.66675L11.6667 1.66675Z" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M11.6667 1.66675V6.66675H16.6667" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M13.3333 10.8333H6.66666" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M13.3333 14.1667H6.66666" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M8.33332 7.5H7.49999H6.66666" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                `,
                                css_properties: 'margin-right: 8px; margin-bottom: 7px; vertical-align: middle;'
                            },
                            enabled:
                            (modules == null ? false : setShowMenuValue(EloadLogsTopups)) ||
                            (modules == null ? false : setShowMenuValue(EloadLogsRewards)) ||
                            (modules == null ? false : setShowMenuValue(EloadLogsSellEload)),
                            subItems: [
                            {
                                label: 'menuitems.eload-transaction-logs.list.top-ups',
                                link: { name: 'Topup Transaction' },
                                enabled: modules == null ? false : setShowMenuValue(EloadLogsTopups)
                            },
                            {
                                label: 'menuitems.eload-transaction-logs.list.loadout',
                                link: { name: 'Eload Transaction' },
                                enabled: modules == null ? false : setShowMenuValue(EloadLogsSellEload)
                            },
                            {
                                label: 'menuitems.eload-transaction-logs.list.rewards',
                                link: { name: 'Eload Rewards' },
                                enabled: modules == null ? false : setShowMenuValue(EloadLogsRewards)
                            }
                            ]
                        },
                        {
                            label: 'GBITS E-Load B2B',
                            customIcon: {
                                icon:
                                 `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M11.6667 1.66675H5.00001C4.55798 1.66675 4.13406 1.84234 3.8215 2.1549C3.50894 2.46746 3.33334 2.89139 3.33334 3.33341V16.6667C3.33334 17.1088 3.50894 17.5327 3.8215 17.8453C4.13406 18.1578 4.55798 18.3334 5.00001 18.3334H15C15.442 18.3334 15.866 18.1578 16.1785 17.8453C16.4911 17.5327 16.6667 17.1088 16.6667 16.6667V6.66675L11.6667 1.66675Z" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M11.6667 1.66675V6.66675H16.6667" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M13.3333 10.8333H6.66666" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M13.3333 14.1667H6.66666" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M8.33332 7.5H7.49999H6.66666" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                `,
                                css_properties: 'margin-right: 8px; margin-bottom: 7px; vertical-align: middle;'
                            },
                            enabled: true,
                            subItems: [
                            {
                                label: 'menuitems.report&logs.gbits.top-ups',
                                link: { name: 'EloadB2B' },
                                enabled: eloadB2b,
                            },
                            {
                                label: 'menuitems.report&logs.gbits.loadout-client',
                                link: { name: 'Coming Soon' },
                                enabled: true,
                            },
                            ]
                        },
                        {
                            label: 'Total E-Load Transaction',
                            customIcon: {
                                icon:
                                 `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M11.6667 1.66675H5.00001C4.55798 1.66675 4.13406 1.84234 3.8215 2.1549C3.50894 2.46746 3.33334 2.89139 3.33334 3.33341V16.6667C3.33334 17.1088 3.50894 17.5327 3.8215 17.8453C4.13406 18.1578 4.55798 18.3334 5.00001 18.3334H15C15.442 18.3334 15.866 18.1578 16.1785 17.8453C16.4911 17.5327 16.6667 17.1088 16.6667 16.6667V6.66675L11.6667 1.66675Z" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M11.6667 1.66675V6.66675H16.6667" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M13.3333 10.8333H6.66666" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M13.3333 14.1667H6.66666" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M8.33332 7.5H7.49999H6.66666" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                `,
                                css_properties: 'margin-right: 8px; margin-bottom: 7px; vertical-align: middle;'
                            },
                            enabled: true,
                            subItems: [
                            {
                                label: 'menuitems.report&logs.total-eload-txn.load-out-total',
                                link: { name: 'Coming Soon' },
                                enabled: true
                            },
                            {
                                label: 'menuitems.report&logs.total-eload-txn.load-out-provider',
                                link: { name: 'Coming Soon' },
                                enabled: true
                            },
                            ]
                        },
                        {
                            label: 'menuitems.bills-payment.report',
                            customIcon: {
                                icon:
                                 `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M11.6667 1.66675H5.00001C4.55798 1.66675 4.13406 1.84234 3.8215 2.1549C3.50894 2.46746 3.33334 2.89139 3.33334 3.33341V16.6667C3.33334 17.1088 3.50894 17.5327 3.8215 17.8453C4.13406 18.1578 4.55798 18.3334 5.00001 18.3334H15C15.442 18.3334 15.866 18.1578 16.1785 17.8453C16.4911 17.5327 16.6667 17.1088 16.6667 16.6667V6.66675L11.6667 1.66675Z" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M11.6667 1.66675V6.66675H16.6667" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M13.3333 10.8333H6.66666" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M13.3333 14.1667H6.66666" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M8.33332 7.5H7.49999H6.66666" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                `,
                                css_properties: 'margin-right: 8px; margin-bottom: 7px; vertical-align: middle;'
                            },
                            enabled:
                            (modules == null ? false : setShowMenuValue(BillsPaymentTopupLogs)) ||
                            (modules == null ? false : setShowMenuValue(BillsPaymentSellLogs)),
                            subItems: [
                            {
                                label: 'menuitems.bills-payment.topup',
                                link: { name: 'Bills Payment Topup' },
                                enabled: modules == null ? false : setShowMenuValue(BillsPaymentTopupLogs)
                            },
                            {
                                label: 'menuitems.bills-payment.sell',
                                link: { name: 'Bills Payment Sell' },
                                enabled: modules == null ? false : setShowMenuValue(BillsPaymentSellLogs)
                            }
                            ]
                        },
                        {
                            label: 'menuitems.topup-transaction-logs.text',
                             customIcon: {
                                icon:
                                 `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M11.6667 1.66675H5.00001C4.55798 1.66675 4.13406 1.84234 3.8215 2.1549C3.50894 2.46746 3.33334 2.89139 3.33334 3.33341V16.6667C3.33334 17.1088 3.50894 17.5327 3.8215 17.8453C4.13406 18.1578 4.55798 18.3334 5.00001 18.3334H15C15.442 18.3334 15.866 18.1578 16.1785 17.8453C16.4911 17.5327 16.6667 17.1088 16.6667 16.6667V6.66675L11.6667 1.66675Z" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M11.6667 1.66675V6.66675H16.6667" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M13.3333 10.8333H6.66666" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M13.3333 14.1667H6.66666" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M8.33332 7.5H7.49999H6.66666" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                `,
                                css_properties: 'margin-right: 8px; margin-bottom: 7px; vertical-align: middle;'
                            },
                            enabled:false,
                            // (modules == null ? false : setShowMenuValue(BLVCKLogTopups)) ||
                            // (modules == null ? false : setShowMenuValue(BLVCKLogRewards)),
                            subItems: [
                            {
                                label: 'menuitems.topup-transaction-logs.list.top-ups',
                                link: { name: 'Home' },
                                enabled: true,
                            },
                            {
                                label: 'menuitems.topup-transaction-logs.list.rewards',
                                link: { name: 'Home' },
                                enabled: true,
                            }
                            ]
                        },
                        {
                            label: 'Kankolek Transaction',
                            customIcon: {
                                icon: `<svg width="20" height="20" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                        <rect width="16" height="13.5" fill="url(#pattern0_16695_7177)"/>
                                        <defs>
                                        <pattern id="pattern0_16695_7177" patternContentUnits="objectBoundingBox" width="1" height="1">
                                        <use xlink:href="#image0_16695_7177" transform="scale(0.03125 0.037037)"/>
                                        </pattern>
                                        <image id="image0_16695_7177" width="32" height="27" preserveAspectRatio="none" xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAbCAYAAAAdx42aAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAF0SURBVHgBvZbBUcMwEEW/kgtHpwN1gDvAdMCVE+kgoYLAjWOoAHzjCBVEVJDQgakgLoFdvIo9GmEcJ9o3s5Gytkff31pJQAdr7ZZiTzGHEpPgfybhoEQowFLsKgJKHASQ7bl0P6FI14FC2gqKdAUspK2hyK8AmfVWcjkU8Q6sOrlLKGLo7QtqN0F+RoWg8inYgZtIfgklWEDM8gU5k0EBFhCbdDz4CgpMZLAYS5kfyQX08ZL6U7CAque6pdikFMECvv65JxcRFokEuAH3eRFznBkj9u6PeKai+KBYn2PbNvxDItZoN6Nj2KHZvh1GniO8AHZhi3ZDGkstorj9ltZHDGd8Tw4kvCeorIBCdVgHyD1Wfg3d80BpwoyUGzthkZZHeumHaZitG56zLGNxBdJwT4M/cWf61x0kwpGIkrozNG5c4HR40bulwd98wgx5SqqEzw13GOeKoyhp4NfwwiABETG5CLlCUzUWbfX4svNrxHvf+vADWhdmHeFOGoUAAAAASUVORK5CYII="/>
                                        </defs>
                                        </svg>
                                `,
                                css_properties: 'margin-left: 3px; margin-bottom: 11px; margin-right: 6px; vertical-align: middle;'
                            },
                            enabled: true,
                            subItems: [
                            {
                                label: 'Transaction Data',
                                link: { name: 'Coming Soon' },
                                enabled: true
                            },
                            {
                                label: 'Adjustment Transaction',
                                link: { name: 'Kankolek Adjustment Index' },
                                enabled: true
                            },
                            ]
                        },
                        {
                            label: 'menuitems.agent-transaction-logs.text',
                            icon: 'user',
                            link: { name: 'Home' }, // TODO::
                            enabled: false
                        },
                        {
                            label: 'menuitems.kankolek.transaction-data',
                            icon: 'data',
                            link: { name: 'Home' }, // TODO: Page doesn't exist yet - needs implementation for Transaction Data
                            enabled: false
                        },
                        ]
                    },

                    /* Others (Collapsible) */
                    {
                        label: 'OTHERS',
                        isTitle: true,
                        isCollapsible: true,
                        enabled: showSettingsTitle,
                        subItems: [
                        {
                            label: 'menuitems.others.notification.advert.title',
                            customIcon: {
                                icon: `<svg width="15" height="20" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M16 11C16 11.442 15.8244 11.866 15.5118 12.1785C15.1993 12.4911 14.7754 12.6667 14.3333 12.6667H4.33333L1 16V2.66667C1 2.22464 1.17559 1.80072 1.48816 1.48816C1.80072 1.17559 2.22464 1 2.66667 1H14.3333C14.7754 1 15.1993 1.17559 15.5118 1.48816C15.8244 1.80072 16 2.22464 16 2.66667V11Z" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                                `,
                                css_properties: 'margin-right: 0px; margin-bottom: 7px; margin-left: 8px; margin-right: 2px; vertical-align: middle;'
                            },
                            enabled: true,
                            subItems: [
                                {
                                    label: 'menuitems.others.notification.advert.eload-banner',
                                    link: { name: 'Coming Soon' },
                                    enabled: true
                                },
                                {
                                    label: 'menuitems.others.notification.advert.admob',
                                    link: { name: 'Coming Soon' },
                                    enabled: true
                                }
                            ]
                        },
                        {
                            label: 'menuitems.notification.text',
                            icon: 'bell',
                            link: { name: 'Notification Index' },
                            enabled: true,
                            subItems: [
                                  {
                                    label: 'menuitems.peddlr-options.text',
                                    // icon: 'food-menu',
                                    modal: { key: 'peddlrOptionsModal' },
                                    enabled: modules == null ? false : setShowMenuValue(AgentTransactionLogs)
                                },
                                {
                                    label: 'menuitems.others.notification.sms-blast',
                                    icon: 'bell',
                                    link: { name: 'SMS Blast Campaign' },
                                    enabled: true,
                                },
                            ]
                        },
                        ]
                    },

                    /* Archive (Collapsible) */
                    {
                        label: 'ARCHIVE',
                        isTitle: true,
                        isCollapsible: true,
                        enabled: showSettingsTitle,
                        subItems: [
                        {
                            label: 'menuitems.archive.list.eload',
                            icon: 'box',
                            enabled: true,
                            subItems: [
                            {
                                label: 'menuitems.digital-offers.list.eload-promo',
                                link: { name: 'E-Load' },
                                enabled: modules == null ? false : setShowMenuValue(eLoadPromo)
                            },
                            {
                                label: 'menuitems.digital-offers.list.eload-provider',
                                link: { name: 'E-Load Provider' },
                                enabled: modules == null ? false : setShowMenuValue(eLoadProvider)
                            },
                            {
                                label: 'menuitems.digital-offers.list.eload-category',
                                link: { name: 'Category Promo' },
                                enabled: modules == null ? false : setShowMenuValue(eLoadCategory)
                            },
                            {
                                label: 'menuitems.digital-offers.list.eload-special-category',
                                link: { name: 'E-Load Special Category' },
                                enabled: true
                            },
                            {
                                label: 'menuitems.digital-offers.list.eload-topups',
                                link: { name: 'E-Load Topups' },
                                enabled: modules == null ? false : setShowMenuValue(eLoadTopups)
                            },
                            {
                                label: 'menuitems.digital-offers.list.eload-network-group',
                                link: { name: 'E-Load Network Group' },
                                enabled: modules == null ? false : setShowMenuValue(eLoadNetworkGroup)
                            },
                            {
                                label: 'menuitems.digital-offers.list.eload-banner',
                                link: { name: 'E-Load Banner' },
                                enabled: modules == null ? false : setShowMenuValue(eLoadBanner)
                            }
                            ]
                        },
                        {
                            label: 'menuitems.archive.list.eloadTransactionLogs',
                            icon: 'box',
                            enabled: true,
                            subItems: [
                            {
                                label: 'menuitems.eload-transaction-logs.list.top-ups',
                                link: { name: 'Topup Transaction' },
                                enabled: modules == null ? false : setShowMenuValue(EloadLogsTopups)
                            },
                            {
                                label: 'menuitems.eload-transaction-logs.list.loadout',
                                link: { name: 'Eload Transaction' },
                                enabled: modules == null ? false : setShowMenuValue(EloadLogsSellEload)
                            },
                            {
                                label: 'menuitems.eload-transaction-logs.list.rewards',
                                link: { name: 'Eload Rewards' },
                                enabled: modules == null ? false : setShowMenuValue(EloadLogsRewards)
                            },
                            ]
                        },
                        {
                            label: 'menuitems.archive.list.billsPaymentTransaction',
                            icon: 'box',
                            enabled: true,
                            subItems: [
                            {
                                label: 'menuitems.bills-payment.topup',
                                link: { name: 'Bills Payment Topup' },
                                enabled: modules == null ? false : setShowMenuValue(BillsPaymentTopupLogs)
                            },
                            {
                                label: 'menuitems.bills-payment.sell',
                                link: { name: 'Bills Payment Sell' },
                                enabled: modules == null ? false : setShowMenuValue(BillsPaymentSellLogs)
                            }
                            ]
                        },
                        {
                            label: 'menuitems.archive.list.blvckbooksTransaction',
                            icon: 'box',
                            enabled: true,
                            subItems: [
                            {
                                label: 'menuitems.topup-transaction-logs.list.top-ups',
                                link: { name: 'BLVCK topup Transaction' },
                                enabled: modules == null ? false : setShowMenuValue(BLVCKLogTopups)
                            },
                            {
                                label: 'menuitems.topup-transaction-logs.list.rewards',
                                link: { name: 'Blvck Coins'},
                                enabled: modules == null ? false : setShowMenuValue(BLVCKLogRewards)
                            }
                            ]
                        },
                        {
                            label: 'menuitems.archive.list.agentTransactionLog',
                            icon: 'box',
                            modal: { key: 'agentModal' },
                            enabled: modules == null ? false : setShowMenuValue(AgentTransactionLogs)
                        },
                        {
                            label: 'menuitems.archive.list.kantoAds',
                            icon: 'box',
                            enabled: true,
                            subItems: [
                            {
                                label: 'menuitems.kanto-ads.list.audit',
                                link: { name: 'Audit Space' },
                                enabled: modules == null ? false : setShowMenuValue(KantoAdsAudit)
                            },
                            {
                                label: 'menuitems.kanto-ads.list.cancel',
                                link: { name: 'Audit Cancellation' },
                                enabled: modules == null ? false : setShowMenuValue(KantoAdsAudit)
                            },
                            {
                                label: 'menuitems.kanto-ads-topup.text',
                                link: { name: 'KantoAdsTopup' },
                                enabled: modules == null ? false : setShowMenuValue(KantoAdsTopup)
                            },
                            {
                                label: 'menuitems.kanto-ads-cashout.text',
                                link: { name: 'KantoAdsCashout' },
                                enabled: modules == null ? false : setShowMenuValue(KantoAdsCashout)
                            }
                            ]
                        },
                        {
                            label: 'menuitems.archive.list.eSupplies',
                            icon: 'box',
                            enabled: true,
                            subItems: [
                            {
                                label: 'menuitems.e-seller.list.account',
                                link: { name: 'ESeller Brand' },
                                enabled: modules == null ? false : setShowMenuValue(Sellers)
                            },
                            {
                                label: 'menuitems.e-seller.list.category',
                                link: { name: 'ESeller Category' },
                                enabled: modules == null ? false : setShowMenuValue(Categories)
                            },
                            {
                                label: 'menuitems.e-seller.list.product',
                                link: { name: 'ESeller Product' },
                                enabled: modules == null ? false : setShowMenuValue(Products)
                            },
                            {
                                label: 'menuitems.e-seller.list.banner',
                                link: { name: 'ESeller Banner' },
                                enabled: modules == null ? false : setShowMenuValue(Banners)
                            },
                            {
                                label: 'menuitems.e-seller.list.orders',
                                link: { name: 'ESeller Orders' },
                                enabled: modules == null ? false : setShowMenuValue(Orders)
                            }
                            ]
                        },
                        {
                            label: 'menuitems.archive.list.prp',
                            icon: 'box',
                            enabled: true,
                            subItems: [
                            {
                                label: 'menuitems.prp.list.reward',
                                // icon: 'wallet-alt',
                                link: { name: 'Peddlr Points' },
                                enabled: modules == null ? false : setShowMenuValue(PRPRewards)
                            },
                            {
                                label: 'menuitems.prp.list.category',
                                // icon: 'wallet-alt',
                                link: { name: 'PRP Category' },
                                enabled: modules == null ? false : setShowMenuValue(PRPCategory)
                            },
                            {
                                label: 'menuitems.prp.list.item',
                                // icon: 'wallet-alt',
                                link: { name: 'PRP Items' },
                                enabled: modules == null ? false : setShowMenuValue(PRPItems)
                            }
                            ]
                        },
                        {
                            label: 'menuitems.ml-diamond.text',
                            icon: 'box',
                            link: { name: 'ML Diamond' },
                            enabled: modules == null ? false : setShowMenuValue(MobileLegendDiamond)
                        },
                        {
                            label: 'menuitems.archive.list.profitSharing',
                            icon: 'box',
                            link: { name: 'Eload Sharing' },
                            enabled: modules == null ? false : setShowMenuValue(ProfitSharing)
                        }
                        ]
                    },

                    /* Excess Menu - Items not in Figma design */
                    {
                        label: 'EXCESS MENU',
                        isTitle: true,
                        isCollapsible: true,
                        enabled: false,
                        subItems: [
                        {
                            label: 'menuitems.kankolek.adjustment-transaction',
                            icon: 'adjustment',
                            link: { name: 'Kankolek Adjustment Index' }, 
                            enabled: true
                        },
                        {
                            label: 'menuitems.customer-loyalty.text',
                            icon: 'building-house',
                            link: { name: 'Home'},
                            enabled: modules == null ? false : setShowMenuValue(CustomerLoyalty)
                        },
                        {
                            label: 'menuitems.blvck.text',
                            icon: 'coin',
                            link: { name: 'Blvck Coins' },
                            enabled: modules == null ? false : setShowMenuValue(BLVCKCoins)
                        },
                        
                        {
                            label: 'menuitems.peddlr-events.text',
                            icon: 'food-menu',
                            link: { name: 'Event List' },
                            enabled: modules == null ? false : setShowMenuValue(Events)
                        },
                        {
                            label: 'menuitems.career.text',
                            icon: 'briefcase-alt',
                            enabled:
                            (modules == null ? false : setShowMenuValue(DepartmentTeam)) ||
                            (modules == null ? false : setShowMenuValue(JobOpening)),
                            subItems: [
                            {
                                label: 'menuitems.career.dept',
                                icon: 'briefcase-alt',
                                link: { name: 'Department Team' },
                                enabled: modules == null ? false : setShowMenuValue(DepartmentTeam)
                            },
                            {
                                label: 'menuitems.career.job',
                                icon: 'briefcase-alt',
                                link: { name: 'Job Opening' },
                                enabled: modules == null ? false : setShowMenuValue(JobOpening)
                            }
                            ]
                        },
                        {
                            label: 'menuitems.user-management.text',
                            icon: 'sitemap',
                            enabled:
                            (modules == null ? false : setShowMenuValue(Roles)) ||
                            (modules == null ? false : setShowMenuValue(Users)),
                            subItems: [
                            {
                                label: 'menuitems.roles.text',
                                link: { name: 'Roles' },
                                enabled: modules == null ? false : setShowMenuValue(Roles)
                            },
                            {
                                label: 'menuitems.user.text',
                                link: { name: 'Users' },
                                enabled: modules == null ? false : setShowMenuValue(Users)
                            }
                            ]
                        },
                      
                        {
                            label: 'menuitems.digital-offers.list.eload-banner',
                            icon: 'image',
                            link: { name: 'E-Load Banner' },
                            enabled: modules == null ? false : setShowMenuValue(eLoadBanner)
                        }
                        ]
                    }
                ];

                resolve(menuItems);
            })
            .catch(({ response }) => {
                console.log('Error: ', response)
                let menuItems = [
                    /* Dashboards */ 
                    {
                        label: 'menuitems.dashboards.text',
                        isTitle: true,
                        enabled: true
                    },
                    
                    {
                        label: 'menuitems.overview.text',
                        icon: 'desktop',
                        link: { name: 'Home'},
                        enabled: true
                    },
                ]
                resolve(menuItems);
            });
        });
}

/*
*  Created by: 	Jero Paolo Balucas
*  Description:	setShowMenuValue - This function will check if module has a value of true 
                for any access: create, read, update, delete, requester, approver
*  Params:		specific module
*/
function setShowMenuValue(module) {
    // check if module is not empty object
    if (Object.keys(module).length) {
        // check if any access: create, read, update, delete, requester, approver has a value of true
        // if yes, return true and the navigation will be shown in the side menu
        if (module.access.create || module.access.read || module.access.update || 
            module.access.delete || module.access.requester || module.access.approver) {
            return true
        } else {
        // else, return false, navigation will be hidden
            return false
        }
    } else {
        return false
    }
}

/*
*  Created by: 	Jero Paolo Balucas
*  Description:	handleUndefinedModule - This function will check if module is undefined
                if undefined, we will handle the value to avoid error in side menu
*/
function handleUndefinedModule(statement) {
    // console.log(":: handleUndefinedModule ::");
    // console.log(statement);
    try {
        return statement != undefined ? statement : {}   
    } catch (error) {
        // console.log(":: handleUndefinedModule ERR::");
        // console.log(error);
        return {}
    }
}

/*
*  Created by: 	John Mark
*  Description:	handleNoPropertyExist - this will handle the property of an object that is not exist
*/
function handleNoPropertyExist(obj,prop,search) {
    // console.log(":: handleNoPropertyExist ::");
    // handleUndefinedModule(BillsPaymentTransactionLogs.submodules.find(({ name }) => name == 'Top-ups'))
    try {
        if(prop != null){
            if(Object.prototype.hasOwnProperty.call(obj, prop)){//obj.hasOwn(prop)){//
                return handleUndefinedModule(obj[prop].find(({ name }) => name == search));
            }else{
                return {};
            }   
        }else{
            return handleUndefinedModule(obj.find(({ name }) => name == search));
        }
    } catch (error) {
        // console.log(":: handleNoPropertyExist ERR::");
        // console.log(error);
        return {};
    }
}
